export const SET_POST_CUSTOM_FIELD_ERROR = 'SET_POST_CUSTOM_FIELD_ERROR';
export const SET_CUSTOM_FIELDS_LIST_ERROR = 'SET_CUSTOM_FIELDS_LIST_ERROR';
export const SET_CUSTOM_FIELDS_LIST = 'SET_CUSTOM_FIELDS_LIST';
export const SET_FETCHING_CUSTOM_FIELDS = 'SET_FETCHING_CUSTOM_FIELDS';
export const SET_SHOW_CUSTOM_FIELDS_MODAL = 'SET_SHOW_CUSTOM_FIELDS_MODAL';
